module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.stepPreview.description_visibility) ? _c('h2', {
    staticClass: "kbx-description",
    style: (_vm.stepStyle('description')),
    attrs: {
      "klickbox-edit-item": "description",
      "klickbox-edit-label": _vm.$t('edit.canvas.question_description')
    }
  }, [(!_vm.stepPreview.isGeneral) ? _c('text-editor', {
    attrs: {
      "content": _vm.stepPreview.description_text,
      "change": _vm.onChange,
      "toolbar": true,
      "placeholder": _vm.$t('edit.canvas.question_description_placeholder')
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.stepPreview.description_text))])], 1) : _vm._e()])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-11bb508e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/step/Description.vue
 ** module id = 763
 ** module chunks = 1
 **/